import zhLocales from './zh';
import cnLocales from './cn';
import enLocales from './en';

export default {
  zh: zhLocales,
  cn: cnLocales,
  english: enLocales,
};
